import React, { FunctionComponent, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, ModalFooter, ModalContent, ModalFooterButtons } from 'ui/molecules/modal';
import Translate from 'ui/atoms/translate';
import { InvestorProductDocument, InvestorProductDocumentsApi } from 'src/api';
import useApiCall from 'src/hooks/use-api-call';

export interface DeleteDocumentConfirmationModalProps {
  onDelete: () => void;
  onModalClose: () => void;
  document?: InvestorProductDocument;
}

const DeleteDocumentConfirmationModal: FunctionComponent<DeleteDocumentConfirmationModalProps> = (props) => {
  const { onDelete, onModalClose, document } = props;

  const { makeAuthenticatedApi, withApi } = useApiCall();

  const api: InvestorProductDocumentsApi = useMemo(
    () => makeAuthenticatedApi(InvestorProductDocumentsApi),
    [makeAuthenticatedApi],
  );

  const onDeleteDocument = useCallback(() => {
    withApi(async () => {
      await api.adminInvestorProductDocumentsDestroy({ id: document?.id || '' });

      onDelete();
    });
  }, [document?.id]);

  return (
    <Modal onClose={onModalClose}>
      <ModalHeader>
        <Translate name="confirmDeleteDocumentModal.title" />
      </ModalHeader>
      <ModalContent>
        <Translate name="confirmDeleteDocumentModal.content" args={[<strong>{document?.document.name}</strong>]} />
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'cancel',
              content: <Translate name="common.close" />,
              onClick: onModalClose,
            },
            {
              name: 'delete',
              content: <Translate name="common.delete" />,
              variant: 'primary',
              type: 'submit',
              size: 'large',
              onClick: onDeleteDocument,
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeleteDocumentConfirmationModal;
